















































































// Importing Alert List Component
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing input field
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing variables
import {PermissionsStaff, RolesStaff} from '@/ts/variables';

export default {
    name: 'TheFormStaff',
    components: {
        BaseAlertList,
        BaseInputField,
    },
    props: {
        user: Object,
        errors: Array,
    },
    data() {
        return {
            roles: {},
            permissions: {},
        };
    },
    methods: {},
    created() {
        this.roles = RolesStaff;
        this.permissions = PermissionsStaff;
    },
};
